import request from '@/utils/server'
 
//  组织列表
export function getList(query) {
    return request({
      url: '/testing/getList',
      method: 'get',
      params: query
    })
  }